import { IOffer, DataType } from './types';

export const fecInfo: IOffer = {
    displayOrder: 0,
    id: 'FEC',
    title: "Fichier des Ecritures Comptables",
    subtitle: "",
    shortTitle: "Analyse du FEC",
    mainText: [
        {
            type: DataType.Text, data: [
                "Le FEC doit être remis lors de chaque contrôle fiscal.",
                "Il est largement utilisé par les vérificateurs pour définir les axes d’investigation du contrôle."
            ]
        }
    ],
    href: "/order/FEC",
    buttonLabel: "Vérifier mon fichier",
    risks: ["Amende de 5000€ ou 10% des droits rappelés", "Rectification du résultat comptable en cas d’incohérence entre le FEC et les déclarations fiscales (Liasse fiscale, 2257, documentation prix de transfert, CA3…)", "Rejet de comptabilité"],
    risksDetail: [
        {
            data: ["Cette obligation est assortie des sanctions suivantes :"],
            type: DataType.Text,
        },
        {
            data: [
                "Application d’une amende égale à 5 000 € ou, en cas de rectification et si le montant est plus élevé, d'une majoration de 10 % des droits mis à la charge du contribuable"
            ],
            type: DataType.List,
        },
        {
            data: [
                "Procédure d’évaluation d'office lorsque le contrôle fiscal ne peut avoir lieu du fait du contribuable ou de tiers."
            ],
            type: DataType.List,
        },
        {
            data: ["La remise d’un FEC contenant des anomalies graves et répétées, peut entrainer un rejet de comptabilité."],
            type: DataType.List,
        }
    ],
    offerLevels: [
        {
            displayOrder: 0,
            code: "FEC_TECH",
            title: "Conformité Technique",
            text: ["Contrôle du respect du format technique spécifié par l’article A 47 A 1 LPF visant à s’assurer de l’acceptation du fichier par l’administration."]
        },
        {
            displayOrder: 1,
            code: "FEC_ACCOUNTING",
            title: "Conformité Comptable",
            text: ["Contrôle du respect des principes comptables français, de la cohérence du résultat comptable avec la balance et la liasse fiscale."]
        },
        {
            displayOrder: 2,
            code: "FEC_TAX",
            title: "Revue IS",
            text: ["Analyse du résultat fiscal à partir du FEC et analyse des risques fiscaux (provisions, prix de transfert, retenue à la source…)."]
        },
        {
            displayOrder: 3,
            code: "FEC_TVA",
            title: "Revue des flux TVA",
            text: [
                "Analyse des flux de produits et de charges (taux de TVA pratiqué, écritures sans TVA…).",
                "Réconciliation avec les déclarations de TVA."
            ]
        },
    ],
    why: {
        title: "Pourquoi se préparer ?",
        paragraph: [
            {
                type: DataType.Text,
                data: [
                    "Il est important de maîtriser l’intégralité des flux comptables contenus dans le FEC qui impactent les déclarations fiscales.",
                    "Réaliser une analyse complète du FEC permet de :"
                ]
            },
            {
                type: DataType.List,
                data: [
                    "Anticiper les questions du vérificateur.",
                    "Reprendre le contrôle de vos données et réaliser des contrôles de cohérence.",
                    "Corriger d’éventuelles anomalies."
                ]
            },
        ]
    },
    docs: [
        "FEC N-1 et N",
        "Balance au format Excel",
        "Liasse au format EDI",
        "Fourchettes de comptes utilisées"
    ],
    tile: {
        title: "Analyse du FEC",
        subtitle: "Fichier des Ecritures Comptables",
        text: [
            "La maitrise de la donnée comptable est essentielle avant tout contrôle fiscal.",
            "TaxAnalytics permet d’exercer des contrôles de cohérence entre les données contenues dans le FEC, la balance et les déclarations fiscales (Liasse fiscale, 2257, documentation prix de transfert, CA3…)."
        ],
        buttonLabel: "En savoir plus",
        href: "/Offer/FEC"
    }
}
export const eInvoiceReporting: IOffer = {
    displayOrder: 1,
    id: 'EINVREP',
    title: "Préparation de la réforme de la facturation électronique",
    subtitle: "",
    shortTitle: "Préparation : Réforme facturation électronique",
    mainText: [
        {
            type: DataType.Caldendar
        },
        {
            type: DataType.Text,
            data: ["Dès septembre 2026, l’ensemble des entreprises aura l’obligation de recevoir les factures sous format électronique."]
        },
    ],
    href: "/order/EINVREP",
    buttonLabel: "Vérifier",
    risks: [
        "E-invoicing : amende de 15€ par facture avec une limite de 15 000€ par an",
        "E-reporting : amende de 250€ / transmission avec une limite de 15 000€ par an"
    ],
    risksDetail: [],
    why: {
        title: "Pourquoi s'y préparer",
        paragraph: [
            {
                type: DataType.Text,
                data: [
                    "Un état des lieux de l’existant doit être réalisé au niveau des flux (via le FEC) et du paramétrage afin de savoir quelles règles seront à mettre en place pour le futur."
                ]
            },
            {
                type: DataType.Text,
                data: [
                    "L’accès à des données plus complètes va permettre à l’administration de réaliser davantage de contrôles de cohérence.",
                    "Les sociétés doivent elles aussi être en mesure de réaliser davantage de contrôles en amont afin d’éviter toute mauvaise surprise."
                ]
            }
        ]
    },
    offerLevels: [
        {
            displayOrder: 0,
            code: "EINVREP_0STD",
            title: "Etat des lieux de l’existant",
            text: [
                "Identification des flux e-invoicing et e-reporting",
                "Revue des paramétrages en place",
                "Rappel des nouvelles règles et impacts"
            ]

        },
        {
            displayOrder: 1,
            code: "EINVREP_1MEDIUM",
            title: "Réalisation de contrôles de cohérence",
            text: [
                "Contrôles avec le FEC",
                "Contrôles avec les différentes données de l'ERP",
                "Mise en place de dashboard"
            ]
        },
        {
            displayOrder: 2,
            code: "EINVREP_2ADVANCED",
            title: "Assistance lors de la mise en place",
            text: [
                "Définition des règles à mettre en place",
                "Assistance dans la modification des paramétrages",
                "Rappel des nouvelles règles et impacts",
            ]
        }
    ],
    docs: [
        "FEC",
        "CA3",
        "Liste clients / Fournisseurs avec adresse",
        "Liasse",
        "Balance comptable",
        "Document piste audit fiable si existante"
    ],
    tile: {
        title: "Préparation de la réforme de la facturation électronique",
        subtitle: "E-Invoicing E-Reporting",
        text: [
            "Cette réforme constitue l’un des défis majeurs pour les sociétés.",
            "La gestion de la transmission des données de facturation et de paiement aux tiers et à l’administration fiscale est essentielle pour les groupes.",
            "Cette réforme doit être anticipée par un accompagnement dédié."
        ],
        buttonLabel: "En savoir plus",
        href: "/Offer/EINVREP"
    }
}
export const prepCFI: IOffer = {
    displayOrder: 2,
    id: 'prepCFI',
    title: "Préparation de l’examen de conformité fiscale",
    subtitle: "",
    shortTitle: "Préparation: Examen de conformité fiscale",
    href: "/order/prepCFI",
    buttonLabel: "Go",
    mainText: [
        {
            type: DataType.Text,
            data: [
                "L'examen de conformité fiscale (ECF), créé par décret du 13 janvier 2021, permet aux entreprises de bénéficier d'une prestation contractuelle renforçant leur sécurité juridique et fiscale.",
                "Un ECF porte sur un exercice fiscal et sur 10 points précis, considérés comme les points fiscaux les plus contrôlés. À savoir :"
            ]
        },
        {
            type: DataType.List,
            data: [
                "La conformité du fichier des écritures comptables",
                "La qualité comptable du fichier FEC",
                "Le régime fiscal choisi",
                "La certification des logiciels de caisse",
                "La TVA (collectée et déductible)",
                "Les amortissements",
                "Les provisions",
                "Les charges à payer",
                "Les charges exceptionnelles",
                "Le mode de conservation des documents"
            ]
        }
    ],
    tile: {
        title: "Préparation de l’examen de conformité fiscale",
        text: [
            "L’examen de conformité fiscale est une nouvelle mesure permettant à une entreprise de renforcer sa sécurité juridique et fiscale à l’aide d’un professionnel de la fiscalité."
        ],
        buttonLabel: "En savoir plus",
        href: "/Offer/prepCFI"
    },
    why: {
        title: "Pourquoi se préparer pour un examen de conformité fiscale ?",
        paragraph: [
            {
                type: DataType.Text,
                data: [
                    "Cette mesure n’exonère pas l’entreprise de ses obligations mais en cas de contrôle entrainant un rappel d’impôt sur un point audité et validé par le prestataire, l’entreprise peut demander le remboursement de la part des honoraires correspondants.",
                    "Par ailleurs, si l’entreprise a bien pris en compte les recommandations formulées par l’auditeur, la DGFIP pourrait ne pas exiger le paiement de pénalité ni d’intérêt de retard.",
                    "Il est recommandé de préparer un examen de conformité fiscale car il est rare que les 10 points d’audit soient conformes dans leur ensemble."
                ]
            }
        ]
    }
}
export const dataGovernance: IOffer = {
    displayOrder: 3,
    id: 'dataGovernance',
    title: "Gouvernance des données & Anticipation du contrôle fiscal informatisé",
    subtitle: "",
    shortTitle: "Gouvernance des données & Anticipation CFI",
    href: "/order/dataGovernance",
    buttonLabel: "Go",
    mainText: [
        {
            type: DataType.Text,
            data: [
                "La digitalisation du contrôle fiscal est en constante progression.",
                "L’accès aux données comptables et aux données de gestion (ventes, achats, stocks, immobilisations…), peut s’avérer complexe techniquement, si la société n’a pas anticipé ce type de demande (ces demandes sont encadrées par des délais stricts.).",
                "Ces demandes visent notamment à vérifier la cohérence des données fiscales déclarées avec celles contenues dans l’ERP en matière de TVA, IS (politique de prix de transfert, montant des dotations de provisions…) taxes locales (TF, CFE…)",
                "L’archivage et le contrôle des données archivées sont essentielles pour répondre aux obligations en cas de contrôle fiscal et ainsi réduire les risques de redressement.",
                "Il est donc important de constituer et vérifier des bases archivées."
            ]
        }
    ],
    tile: {
        title: "Gouvernance des données",
        subtitle: "Anticipation d’un contrôle fiscal informatisé",
        text: [
            "Les données qui concourent directement ou indirectement aux résultats comptables et fiscales et à l’ensemble des déclarations fiscales doivent être conservées pendant les délais déterminés par la loi."
        ],
        buttonLabel: "En savoir plus",
        href: "/Offer/dataGovernance"
    },
    why: {
        title: "Pourquoi mettre en place une politique de gouvernance des données ?",
        paragraph: [
            {
                type: DataType.Text,
                data: [
                    "Les ERP n’ont pas été conçu pour répondre aux exigences fiscales en matière de gouvernance des données. La notion d’archive et de sauvegarde ne correspondent pas à la même chose. Une confusion entre ces deux notions est fréquente mais elles ont pourtant un but distinct.",
                    "La sauvegarde des données d’un ERP ne permet pas de répondre aux obligations comptables et fiscales.",
                    "L’une des raisons évidentes est la modification a posteriori de certaines données pouvant entrainer des conséquences fiscales non négligeables.",
                    "L’anticipation de certaines demandes types peut permettre à l’entreprise d’identifier et de justifier d’éventuelles incohérences entre les données déclarées et les données contenues dans l’ERP :"
                ]
            },
            {
                type: DataType.List,
                data: [
                    "En matière de TVA",
                    "En matière d’application de la politique des prix de transfert",
                    "En termes de calcul des provisions pour dépréciation",
                    "En termes de calcul des bases d’impôts locaux"
                ]
            },
            {
                type: DataType.Text,
                data: [
                    "La mise en place des procédures relatives à l’exploitation des données permet de réduire les risques en cas de demandes de traitement informatisées."
                ]
            }
        ]
    },
    offerLevels: [
        {
            displayOrder: 0,
            code: "DATAGOV_STD",
            title: "Basique",
            text: ["Rappel de la réglementation, délais et conditions de conservation"]

        },
        {
            displayOrder: 1,
            code: "DATAGOV_MEDIUM",
            title: "Intermédiaire",
            text: [
                "Audit de la disponibilité et fiabilité des données sur un thème choisi (stock, TVA, immobilisations, prix de transfert…)."
            ]
        },
        {
            displayOrder: 2,
            code: "DATAGOV_ADVANCED",
            title: "Complète",
            text: [
                "Réalisation d’une demande de traitement sur un thème choisi , rapprochement avec le FEC et les déclarations."
            ]
        }
    ],
    risks: [
        "Le défaut de présentation des documents, données et traitements.",
        "Application d’une amende de 5 000 € ou majoration de 10% des droits mis à la charge du contribuable (redressements liés aux traitements informatiques).",
        "Les bases d’imposition peuvent être évaluées d’office en cas d’opposition à la mise en œuvre du contrôle des comptabilités informatisées."
    ],
    docs: [
        "Cartographie informatique",
        "Données relatives aux ventes",
        "Données relatives aux achats",
        "Données relatives aux immobilisations"
    ],
}
export const erpConfiguration: IOffer = {
    displayOrder: 4,
    id: 'erpConfiguration',
    title: "Audit et assistance au paramétrage de l’ERP",
    shortTitle: "Audit et assistance au paramétrage de l’ERP",
    href: "/order/erpConfiguration",
    buttonLabel: "Demander un accompagnement",
    mainText: [
        {
            type: DataType.Text,
            data: [
                "Les données comptables et fiscales sont gérées par l’ERP et constituent donc l’origine de l’ensemble des déclarations fiscales des entreprises.",
                "Il est donc opportun de réaliser un audit du paramétrage de l’ERP :"
            ]
        },
        {
            type: DataType.List,
            data: [
                "Pour faire un état des lieux",
                "Lors d’une migration d’un ERP",
                "D’un changement d’ERP",
                "Lors d’une due diligence"
            ]
        },
    ],
    tile: {
        title: "Audit et assistance au paramétrage de l’ERP",
        text: [
            "La conformité du paramétrage de l’ERP avec les règles comptables et fiscales est essentielle pour maitriser et éviter les risques fiscaux.",
            "En effet les données que contient l’ERP concourent directement ou indirectement aux résultats comptables et fiscaux et aux déclarations TVA."
        ],
        buttonLabel: "En savoir plus",
        href: "/Offer/erpConfiguration"
    },
    why: {
        title: "Pourquoi auditer son ERP ?",
        paragraph: [{
            type: DataType.List,
            data: [
                "Vérifier la conformité des règles comptables et fiscales",
                "Anticiper une demande de traitement informatisée",
                "Anticiper la réforme de la facturation électronique",
                "Anticiper l’exploitation des données comptables et fiscales par l’administration fiscal (data-mining)"
            ]
        }]
    },
    risks: [
        "Rectification du résultat comptable, des montants de TVA",
        "Pénalités"
    ],
    risksDetail: [],
    subOffers: []
}
export const fecFiscalReview: IOffer = {
    displayOrder: 5,
    id: 'FiscalReview',
    title: "Revue fiscale à partir du FEC",
    subtitle: "",
    shortTitle: "Revue fiscale à partir du FEC",
    href: "/order/FiscalReview",
    buttonLabel: "Vérifier mon FEC",
    mainText: [
        {
            type: DataType.Text, data: [
                "Le FEC doit être remis pour chaque exercice contrôlé lors du premier rendez-vous avec l’administration fiscale.",
                "Il est largement utilisé par les vérificateurs pour définir les axes d’investigation du contrôle."
            ]
        }
    ],
    docs: [
        "FEC N-1 et N",
        "Balance au format Excel",
        "Liasse au format EDI",
        "Fourchettes de comptes utilisées au format Excel",
        "Déclarations TVA"
    ],
    tile: {
        title: "Revue fiscale à partir du FEC",
        text: [
            "Le FEC contient l’intégralité des flux comptables de l’exercice.",
            "Les déclarations fiscales découlent de la comptabilité.",
            "La revue fiscale doit donc être faite à partir du FEC"
        ],
        buttonLabel: "En savoir plus",
        href: "/Offer/FiscalReview"
    },
    offerLevels: [
        {
            displayOrder: 0,
            code: "FiscalReview_IS",
            title: "Revue IS",
            text: ["Analyse du résultat fiscal à partir du FEC et analyse des risques fiscaux (provisions, prix de transfert, retenue à la source…)."]
        },
        {
            displayOrder: 1,
            code: "FiscalReview_TVA",
            title: "Revue des flux TVA",
            text: [
                "Analyse des flux de produits (taux de collecte pratiqué par client, produits sans TVA collectée…).",
                "Analyse des flux de charges (taux de déduction pratiqué par fournisseur, charges sans TVA déduite).",
                "Réconciliation déclarations TVA."
            ]
        },
    ],
    why: {
        title: "Pourquoi se préparer ?",
        paragraph: [
            {
                type: DataType.Text, data: [
                    "Le FEC représente l’exact reflet de la comptabilité contenue dans l'ERP et constitue donc le résultat comptable de l’entité vérifiée.",
                    "Il est important de maitriser la donnée comptablo-fiscale pour s’assurer de la cohérence des informations présentes dans la liasse fiscale."
                ]
            }
        ]
    }
}
export const revueFiscaliteLocale: IOffer = {
    displayOrder: 6,
    id: 'REVUEFL',
    title: "Revue des bases de la fiscalité locale",
    shortTitle: "Revue des bases de la fiscalité locale",
    mainText: [
        {
            type: DataType.Text,
            data: [
                "La complexité du calcul des impôts locaux (méthode des locaux commerciaux ou industriels, taxes d’urbanisme) empêche les entreprises d’avoir une visibilité sur leur charge d’impôt et d’éviter les surimpositions."
            ]
        },
    ],
    href: "/order/revuefl",
    buttonLabel: "Revoir ma fiscalité locale",
    risks: ["Base d’imposition erronée entrainant une hausse d’impôt."],
    why: {
        title: "Pourquoi auditer ses bases ?",
        paragraph: [
            {
                type: DataType.Text,
                data: [
                    "En dépit des réformes sur l’évaluation des valeurs locatives des locaux professionnels (2017) ou pour les établissements industriels, les impôts locaux représentent encore un poids que les entreprises ne peuvent négliger.",
                    "Il est donc important de réaliser une revue des valeurs locatives afin de sécuriser et optimiser ses bases imposables et payer le juste impôt.",
                    "Il convient de s'assurer que l'on disposer d’un suivi suffisant en termes de fiscalité locale à la fois sur :"
                ]
            },
            {
                type: DataType.List,
                data: [
                    "Le nombre de m² pour les locaux professionnels;",
                    "Les immobilisations mises au rebut ou non pour les établissements industriels;",
                    "Une incohérence entre les données de calcul de la CVAE et le FEC;",
                    "Une mauvaise gestion des taxes et participation d’urbanisme.",
                ]
            },
            {
                type: DataType.Text,
                data: ["Réaliser un audit sur ces thématiques s’avère nécessaire et peut permettre de réduire le montant de l’impôt."]
            }
        ]
    },
    tile: {
        title: "Revue des bases de la fiscalité locale",
        text: [
            "La fiscalité local représente un cout non négligeable pour les entreprises en dépit des récents réformes concernant les impôts de production (calcul de la Valeur locative des établissements industriels, suppression progressive de la CVAE).",
            "Suite à la réforme de 2021 qui a allégé l’imposition des établissements industriels et la jurisprudence récente, il convient de sécuriser ses bases suite aux augmentations constatés des taux d’impositions votés par les collectivités territoriales suite à ces réformes."
        ],
        buttonLabel: "En savoir plus",
        href: "/Offer/RevueFL"
    },
    subOffers: []
}
export const pafInfo: IOffer = {
    displayOrder: 7,
    id: 'PAF',
    title: "Piste d'audit fiable",
    subtitle: "Préparation d’une documentation complète ou revue d’une documentation existante",
    shortTitle: "PAF - Piste d'audit fiable",
    mainText: [
        {
            type: DataType.Text, data: [
                "Depuis le 1er janvier 2013, une facture envoyée ou reçue sous tout format autre que l’EDI fiscal ou la signature électronique avancée constitue une facture originale sous réserve de disposer d’une Piste d’Audit Fiable.",
                "Les contribuables doivent donc disposer d’une Piste d’Audit Fiable (PAF) décrivant l’ensemble du processus de facturation et la nature des contrôles effectués, afin d’établir le lien entre la facture, le traitement comptable / IT / fiscal et la réalité de l’opération facturée.",
                "Cette obligation de constituer une PAF concerne tant les factures à l’achat que les factures à la vente.",
                "Cette documentation doit pouvoir être remise à l’administration fiscale pour tous les exercices ouverts à contrôle."
            ]
        },
    ],
    href: "/order/paf",
    buttonLabel: "Auditer ma piste d'audit fiable",
    risks: ["Pour les factures d’achats : une remise en cause du droit à déduction de la TVA", "Pour les factures de ventes : une amende fiscale égale à 50% du montant de la vente pour défaut d’émission de facture"],
    risksDetail: [
        {
            data: ["Le défaut d’une documentation de piste d’audit fiable ou une documentation insuffisante peut entrainer :"],
            type: DataType.Text,
        },
        {
            children: [
                {
                    type: DataType.List,
                    data: ["Pour les factures d’achats :"],
                    children: [
                        {
                            type: DataType.List,
                            data: [
                                "Une remise en cause du droit à déduction de la TVA ."
                            ]
                        }
                    ]
                },
                {
                    type: DataType.List,
                    data: ["Pour les factures de ventes :"],
                    children: [
                        {
                            type: DataType.List,
                            data: ["Une amende fiscale égale à 50% du montant de la vente pour défaut d’émission de facture, , réduite à 5% si les opérations sont correctement comptabilisées. Le montant de l’amende est plafonné à 375 000 € par exercice (si le chiffre d’affaires annuel dépasse 750 000€) ou 37 500 € si la société apporte la preuve que les opérations constitutives du chiffre d’affaires ont été régulièrement comptabilisées."]
                        }
                    ]
                }
            ],
            type: DataType.List,
        },
        {
            data: ["Enfin celle-ci se voit également appliquer un coefficient de neutralisation, un dispositif du planchonnement et un mécanisme de lissage."],
            type: DataType.Text,
        }
    ],
    offerLevels: [
        {
            displayOrder: 0,
            code: "AUDIT_PAF_STD",
            title: "Basique",
            text: ["Contrôle des informations transmises à l'administration fiscale"]
        },
        {
            displayOrder: 1,
            code: "AUDIT_PAF_MEDIUM",
            title: "Intermédiaire",
            text: ["Audit TVA / facturation complet et identification des zones de risque"],
        },
        {
            displayOrder: 2,
            code: "AUDIT_PAF_FULL",
            title: "Complète",
            text: ["Conformité fiscale et sécurisation de la TVA déductible"],
        },
    ],
    why: {
        title: "Pourquoi se préparer ?",
        paragraph: [
            {
                type: DataType.Text,
                data: [
                    "La PAF est désormais très fréquemment demandée par les inspecteurs lors des contrôles fiscaux.",
                    "La préparation de cette documentation pouvant être très chronophage, il est important pour les sociétés de la préparer avant toute demande de l’administration.",
                    "De plus, compte tenu de l’ampleur des informations contenues dans cette documentation(et donc communiquées à l’administration fiscale), il nous semble important que les PAF préparées en interne par les sociétés soient revues afin de contrôler les informations transmises."
                ]
            }
        ]
    },
    docs: [
        "Balances générales, liasse fiscale et déclarations de TVA (pour N-1)",
        "Brève description de l’ERP et des outils IT utilisés pour le traitement des factures",
        "Copie des procédures internes existantes concernant les process achat, vente et TVA.",
        "Copie de la documentation PAF existante"
    ],
    tile: {
        title: "Revue de la Piste d’Audit Fiable",
        text: [
            "La documentation de la piste d’audit fiable doit être remise en cas de contrôle fiscal.",
            "Cette documentation permet de retracer les différentes étapes des opérations réalisées par l’entreprise.",
            "Il est important de constituer cette documentation et de s’assurer de sa conformité."
        ],
        buttonLabel: "En savoir plus",
        href: "/Offer/PAF"
    }
}
export const invoiceModelReview: IOffer = {
    displayOrder: 8,
    id: 'invoiceModelReview',
    title: "Audit du respect des obligations en matière de facturation",
    subtitle: "Revue des modèles de facture et identification des mentions obligatoires manquantes",
    shortTitle: "Revue des modèles de facture et identification des mentions obligatoires manquantes",
    href: "/order/invoiceModelReview",
    buttonLabel: "Contrôler les mentions obligatoires",
    mainText: [
        {
            type: DataType.Text,
            data: [
                "Il résulte des dispositions du code général des impôts (CGI) que les factures doivent obligatoirement comporter certaines mentions.",
                "En plus des mentions communes à toutes les opérations réalisées (numéro de TVA, numéro de facture, date de facture, etc.), de nombreuses mentions spécifiques doivent obligatoirement être ajoutées pour certains flux particuliers (principalement pour les factures émises sans TVA du fait d’une exonération, une suspension, ou une règle relative à la territorialité de la taxe)."
            ]
        }
    ],
    risks: ["Application d'une amende en cas de manquement", "15€ par omission/inexactitude", "Plafonnement à 25% du montant total de la facture"],
    risksDetail: [
        {
            type: DataType.Text,
            data: [
                "En cas de contrôle fiscal, tout manquement peut donner lieu à l’application d’une amende.",
                "L’article 1737 du CGI dispose en effet que chaque omission ou inexactitude est sanctionnée par une amende de 15 €. Lorsqu'une facture comporte plusieurs omissions ou inexactitudes, le montant total des amendes dues à ce titre est plafonné à 25 % du montant total de la facture.",
                "Si le montant de l’amende semble à première vue limité, son application à un très grand nombre de factures émises au cours de la période ouverte à contrôle est susceptible de représenter un montant total significatif."
            ]
        }
    ],
    docs: [
        "Liste des différentes typologies de flux réalisés par la société (afin d’identifier les mentions spécifiques devant apparaître sur les factures)",
        "1 exemple de facture émise pour chaque typologie de flux"
    ],
    tile: {
        title: "Audit du respect des obligations en matière de facturation",
        text: [
            "Le respect des mentions obligatoires des factures incombe à l’ensemble des entreprises.",
            "Il est important de vérifier la correcte application de ces mentions."
        ],
        buttonLabel: "En savoir plus",
        href: "/Offer/invoiceModelReview"
    },
    why: {
        title: "Déroulement de la mission et livrable",
        paragraph: [{
            type: DataType.Text,
            data: [
                "Après réception des documents, une personne de notre équipe prendra contact avec vous pour valider la bonne réception des documents, les attentes, le calendrier et les honoraires.",
                "Une fois la liste des typologies d’opérations validée/précisée, notre équipe réalisera une revue, facture par facture, afin d’identifier les potentielles omissions à corriger.",
                "Un rapport de synthèse mentionnant l’intégralité des omissions identifiées lors de notre analyse, ainsi que nos commentaires et recommandations pour y remédier."
            ]
        }]
    }
}


export const cvaeInfo: IOffer = {
    displayOrder: 0,
    id: 'CVAE',
    title: "CVAE",
    subtitle: "Cotisation sur la Valeur Ajoutée",
    shortTitle: "CVAE - Cotisation sur la Valeur Ajoutée",
    mainText: [
        {
            type: DataType.Text, data: [
                "La CVAE (Cotisation sur la Valeur Ajoutée) est un composant de la Contribution Economique Territoriale.",
                "Elle est déterminée en fonction du chiffre d’affaires réalisé et de la valeur ajoutée produite au cours de l’exercice de référence par la société.",
                "La détermination de la VA dans le calcul de la CVAE représente un exercice difficile notamment en raison de règles fiscales et d’une jurisprudence complexe."
            ]
        },
    ],
    href: "/order/cvae",
    buttonLabel: "Auditer ma CVAE",
    risks: ["Redressements en cas de calculs erronés"],
    risksDetail: [
        {
            data: ["La CVAE fait l’objet d’un contrôle accru de la part de l’administration fiscale entre le FEC (remis en début de contrôle fiscal) et les données comptables retenues pour la détermination de la VA de la CVAE.", "Par conséquent lors du calcul de la CVAE, la société doit être vigilante à la cohérence entre la VA et le CA calculés et les données comptables contenues dans le FEC."],
            type: DataType.Text,
        }
    ],
    offerLevels: [
        {
            displayOrder: 0,
            code: "CVAE_STD",
            subtitle: "Basique",
            title: "Basique",
            text: ["Audit de la VA déclarée vs Balance"]
        },
        {
            displayOrder: 1,
            code: "CVAE_MEDIUM",
            subtitle: "Intermédiaire",
            title: "Intermédiaire",
            text: ["Audit VA déclarée et contrôle de cohérence avec le FEC "]
        },
        {
            displayOrder: 2,
            code: "CVAE_FULL",
            subtitle: "Complète",
            title: "Complète",
            text: ["Audit VA déclarée, contrôle de cohérence, piste d'optimisation"]
        },
    ],
    why: {
        title: "Pourquoi se préparer ?",
        paragraph: [
            {
                type: DataType.Text,
                data: [
                    "Plusieurs risques majeurs reposent sur le contribuable, il est donc important pour celui-ci de sécuriser, contrôler et optimiser sa valeur ajoutée.",
                    "La CVAE fait l’objet d’un contrôle accru de la part de l’administration fiscale.",
                    "Le fait d’utiliser le FEC  pour contrôler la cohérence des données comptables retenues pour la détermination de la VA de la CVAE permet d’anticiper un éventuel contrôle fiscal.",
                    "En effet, la société doit être vigilante à la cohérence entre la VA et le CA calculés et les données comptables contenues dans le FEC."
                ]
            }
        ]
    },
    docs: [
        "Balance",
        "Liasse fiscale (2059E)",
        "FEC (croisement des données entre le FEC, la balance et la VA déclarée)",
        "Déclaration 1323 et 1330"
    ],
    tile: {
        title: "CVAE",
        subtitle: "Cotisation sur la valeur ajoutée",
        text: [],
        buttonLabel: "En savoir plus",
        href: "/Offer/Cvae"
    }
};
export const etabInduInfo: IOffer = {
    displayOrder: 1,
    id: 'EtabIndu',
    title: "Etablissements industriels : Taxe Foncière et CFE",
    subtitle: "Gestion de la Taxe Foncière et de la Cotisation Foncière des Entreprises",
    shortTitle: "Fiscalité locale (Etablissements industriels) - Gestion de la Taxe Foncière et de la Cotisation Foncière des Entreprises",
    href: "/order/etabindu",
    buttonLabel: "Auditer ma valeur ajoutée",
    mainText: [
        {
            type: DataType.Text,
            data: [
                "La valeur locative d’un établissement industriel sert de base d’imposition pour la Taxe Foncière et la Cotisation Foncière des Entreprises.",
                "La méthode de détermination de la valeur locative de ceux-ci diffère de celle des locaux professionnels.",
                "Ainsi :"
            ]
        },
        {
            type: DataType.List,
            data: [
                "Revêt un caractère industriel, le site qui est composé de bâtiments et terrains servant à l’exercice d’une activité de fabrication ou de transformation de biens corporels mobiliers qui nécessite d’importants moyens techniques;",
                "Revêt également un caractère industriel, le site qui est composé des bâtiments et terrains servant à l’exercice d’activités qui nécessitent d’importants moyens techniques lorsque le rôle des installations techniques, matériels et outillages mis en œuvre est prépondérant."
            ]
        },
        {
            type: DataType.Text,
            data: [
                "La valeur locative des établissements industriels s’établit notamment à partir du prix de revient des terrains, constructions et agencements des constructions de l’établissement sur lequel vont venir s’appliquer plusieurs coefficients.",
                "Les données comptables jouent donc un rôle essentiel dans la détermination de la Taxe Foncière et de la Cotisation Foncière des Entreprises."
            ]
        }
    ],
    risks: ["Difficultés à justifier les bases", "Base d’imposition erronée entourant une hausse des impositions."],
    risksDetail: [
        {
            data: [
                "La complexité des règles pour déterminer la valeur locative des établissements industriels ainsi que la qualité de la donnée comptable entrainent des difficultés pour s’assurer de payer le juste impôt.",
                "Lors de chaque contrôle fiscal, l’administration peut vérifier les bases d’imposition et les rehausser (en prenant en compte les nouveaux aménagements et immobilisations n’ayant pas fait l’objet de déclarations) créant une hausse significative des cotisations de Taxe foncière et de Cotisation Foncière des Entreprises."
            ],
            type: DataType.Text,
        }
    ],
    offerLevels: [
        {
            displayOrder: 0,
            code: "ETABINDU_STD",
            title: "Basique",
            text: ["Contrôle des valeurs locatives entre les avis de la Taxe Foncière et de la Cotisation Foncière des entreprises."]
        },
        {
            displayOrder: 1,
            code: "ETABINDU_MEDIUM",
            title: "Intermediaire",
            text: ["Offre basique + Contrôle des valeurs locatives à partir du registre des immobilisation."]
        },
        {
            displayOrder: 2,
            code: "ETABINDU_FULL",
            title: "Avancé",
            text: ["Offre basique + Intermédiaire + Nettoyage des bases et cohérence avec le FEC + Rédaction éventuelle de réclamations."],
        }
    ],
    docs: [
        "Avis de TF et CFE sur les exercices audités",
        "Registre des immobilisations",
        "FEC",
        "Documents échangés lors du dernier contrôle fiscal du/des site/s"
    ],
    why: {
        title: "Pourquoi se préparer ?",
        paragraph: [
            {
                type: DataType.Text,
                data: [
                    "La valeur locative des établissements industriels est déterminée à partir du registre des immobilisations du contribuable.",
                    "La valeur retenue est le prix de revient et non la valeur nette comptable.",
                    "C’est pour cette raison qu’il est nécessaire d’avoir un registre des immobilisations reflétant la réalité et ne contenant pas des immobilisations mises au rebut par exemple pour ne pas être surimposé."
                ]
            }
        ]
    },
    tile: {
        title: "Etablissements industriels",
        subtitle: "Valeur locative",
        text: [],
        buttonLabel: "En savoir plus",
        href: "/Offer/EtabIndu"
    }
};
export const proLocInfo: IOffer = {
    displayOrder: 2,
    id: 'LocauxPro',
    title: "Fiscalité locale - Locaux professionnels ",
    subtitle: "Gestion de la Taxe Foncière et de la Cotisation Foncière des Entreprises",
    shortTitle: "Fiscalité locale (Locaux professionnels) - Gestion de la Taxe Foncière et de la Cotisation Foncière des Entreprises",
    href: "/order/locauxpro",
    buttonLabel: "Auditer mes valeurs locatives",
    mainText: [
        {
            type: DataType.Text,
            data: [
                "La valeur locative des locaux professionnels sert de base d’imposition de la Taxe Foncière et de la Cotisation Foncière des Entreprises.",
                "Une révision des valeurs locatives a eu lieu en 2017."]
        }
    ],
    risks: ["Révision des valeurs locatives", "Prise en compte d'un nouveau tarif au m² et des coefficients de localisation et pondération", "Application de coefficient de neutralisation", "Dispositif de planchonnement et lissage"],
    risksDetail: [
        {
            data: [
                "Cette révision des valeurs locatives des locaux professionnels et commerciaux a eu pour effet d’appliquer une nouvelle valeur locative pour la détermination de la Taxe Foncière et de la Cotisation Foncière des Entreprises. ",
                "Chaque local professionnel dispose d’une nouvelle valeur locative révisée impliquant la prise en compte des éléments suivants : un tarif au m2 en fonction de la catégorie et du secteur du local ainsi que des coefficients de localisation et pondération.",
                "Enfin celle-ci se voit également appliquer un coefficient de neutralisation, un dispositif du planchonnement et un mécanisme de lissage."
            ],
            type: DataType.Text,
        }
    ],
    why: {
        title: "Pourquoi auditer ses valeurs locatives sur les locaux commerciaux ?",
        paragraph: [
            {
                type: DataType.Text,
                data: [
                    "La révision de la valeur locative des locaux commerciaux est à l’origine d’une hausse ou d’une baisse de l’impôt dû au titre de la Taxe Foncière et de la Cotisation Foncière des Entreprises.",
                    "Depuis 2017, il est donc important de s’assurer du paiement du juste impôt dû et de le réduire en cas de surimposition.",
                    "Une analyse approfondie des éléments ayant permis de déterminer la nouvelle valeur locative de vos locaux professionnels est donc nécessaire pour pouvoir s’assurer de l’application de la valeur locative exacte à vos locaux professionnels.",
                    "Dans le cas contraire, des réclamations peuvent être rédigées afin de bénéficier d’un dégrèvement d’impôt sur le passé et ainsi bénéficier de l’application de la valeur locative correcte pour le futur."
                ]
            }
        ]
    },
    offerLevels: [
        {
            displayOrder: 0,
            code: "VL_STEP1",
            subtitle: "Etape 1",
            title: "Audit des Valeurs Locatives (TF et CFE)",
            tests: [
                { name: "Audit des VA entre les avis TF et CFE", included: true },
                { name: "Audit des VL TF/CFE at déclaration 6660 REV / Autres documents", included: false },
                { name: "Rédaction de réclamation contentieuses", included: false }
            ]
        },
        {
            displayOrder: 1,
            code: "VL_STEP1",
            subtitle: "Etape 2",
            title: "Audit des Valeurs Locatives (Déclaration 6660 REV)",
            tests: [
                { name: "Audit des VA entre les avis TF et CFE", included: true },
                { name: "Audit des VL TF/CFE at déclaration 6660 REV / Autres documents", included: true },
                { name: "Rédaction de réclamation contentieuses", included: false }
            ]
        },
        {
            displayOrder: 2,
            code: "VL_STEP1",
            subtitle: "Etape 3",
            title: "Rédaction de réclamation contentieuses",
            tests: [
                { name: "Audit des VA entre les avis TF et CFE", included: true },
                { name: "Audit des VL TF/CFE at déclaration 6660 REV / Autres documents", included: true },
                { name: "Rédaction de réclamation contentieuses", included: true }
            ]
        }
    ],
    docs: [
        "Avis de TF et CFE sur les exercices audités",
        "Déclaration 6660-REV réalisée par le propriétaire des locaux commerciaux",
        "Contrat de bail",
        "Tout document permettant d’établir les caractéristiques des locaux",
        "Documents échangés lors du dernier contrôle fiscal du/des site/s"
    ],
    tile: {
        title: "Locaux professionnels ",
        subtitle: "Valeur Locative",
        text: [],
        buttonLabel: "En savoir plus",
        href: "/Offer/locauxpro"
    }
}
export const lpTaxesUrbanisme: IOffer = {
    displayOrder: 3,
    id: 'lptaxesurbanisme',
    title: "Locaux professionnels",
    subtitle: "Gestion des taxes et participations d'urbanisme",
    shortTitle: "Fiscalité locale (Locaux professionnels) - Gestion des taxes et participations d'urbanisme",
    href: "/order/lptaxesurbanisme",
    buttonLabel: "Auditer mes taxes et participations d'urbanisme",
    mainText: [
        {
            type: DataType.Text,
            data: [
                "Les surfaces construites (certains aménagements, installations ou les espaces de stationnements) sont sujettes à nombre de taxes et participations d’urbanisme (taxe d'aménagement, redevance d'archéologie préventive et, pour l'Ile de France, la redevance pour création de bureaux, locaux commerciaux et de stockage et taxe sur le stationnement).",
                "Ces taxes concernent toute personne déposant un permis de construire (particulier, entreprises, associations) et ce, dans tous les secteurs (Immobilier, secteur du locatif social, etc.)."
            ]
        }
    ],
    risks: ["Taxes avec des erreurs"],
    risksDetail: [
        {
            data: [
                "Ces surfaces, en fonction de leur affectation, de la qualité du contribuable (société commerciale, organisme sans but lucratif, particulier), de leur localisation (Zone d’aménagement concerté, Ile-de-France, etc.) sont appréhendées différemment (application de coefficient de pondération, application d’exonération, application de taux réduits, etc.).",
                "Mal renseignées ou mal identifiées dans le permis de construire, ces surfaces peuvent générer des taxes avec des erreurs."
            ],
            type: DataType.Text,
        }
    ],
    offerLevels: [
        {
            displayOrder: 0,
            code: "VL_STEP1",
            title: "Audit des surfaces projetées",
            tests: []
        },
        {
            displayOrder: 1,
            code: "VL_STEP1",
            title: "Détermination des taxes et participations d'urbanisme effectivement dues",
            tests: []
        },
        {
            displayOrder: 2,
            code: "VL_STEP1",
            title: "Rédaction de réclamations contentieuses",
            tests: []
        }
    ],
    why: {
        title: "Pourquoi et quand auditer ses taxes et participations d’urbanisme ?",
        paragraph: [
            {
                type: DataType.Text,
                data: [
                    "L’ensemble de ces taxes et participation d’urbanisme ont pour point commun d’être la conséquence du dépôt d’un permis de construire et sont notamment appelées en « one shot » (sous une ou plusieurs échéances).",
                    "Aussi, aux fins de s’assurer du paiement du juste impôt dû, ces taxes et participations d’urbanisme peuvent faire l’objet d’un audit :"]
            },
            {
                type: DataType.List,
                data: [
                    "En amont d’un projet immobilier (construction, changement d’affectation d’un local), aux fins d’identifier le coût financier de ces derniers.",
                    "A l’achèvement d’un projet immobilier, dans l’hypothèse où l’affectation des surfaces ne serait correcte, ou tout simplement aux fins de s’assurer que les surfaces projetées ont bel et bien été réalisées.",
                    "Lors d’un contrôle fiscal.",
                ]
            },
            {
                type: DataType.Text,
                data: [
                    "Nos équipes sont en mesure de réaliser une estimation globale des taxes et participations d’urbanisme dont vous ferez l’objet et d’identifier en fonction de la localisation géographique ou des particularités juridiques de votre projet, des optimisations liées notamment à l’application d’exonération.",
                    "Si l’audit est réalisé postérieurement à l’achèvement du projet immobilier ou postérieurement à un contrôle fiscal, des réclamations peuvent être rédigées afin de bénéficier d’un dégrèvement d’impôt."
                ]
            },
        ]
    },
    docs: [
        "Copie du ou des permis de construire déposés (ainsi que les permis de construire modificatifs)",
        "Une description du projet et des surfaces envisagées en mètres carrés (Détail des surfaces projetées, affectation des surfaces (stationnement, locaux commerciaux, atelier, etc.).",
        "Le cas échéant, les avis d’imposition d’ores et déjà envoyés",
        "Le cas échéant, la date d’achèvement du projet"
    ],
    tile: {
        title: "Gestion des taxes et participations d'urbanisme",
        text: [],
        buttonLabel: "En savoir plus",
        href: "/Offer/lptaxesurbanisme"
    }
}
revueFiscaliteLocale.subOffers?.push(cvaeInfo);
revueFiscaliteLocale.subOffers?.push(etabInduInfo);
revueFiscaliteLocale.subOffers?.push(proLocInfo);
revueFiscaliteLocale.subOffers?.push(lpTaxesUrbanisme);

export const erpGlobalAudit: IOffer = {
    displayOrder: 0,
    id: 'erpGlobalAudit',
    title: "Paramétrage de l’ERP - Audit Global",
    shortTitle: "Paramétrage de l’ERP - Audit Global",
    href: "/order/erpglobalaudit",
    buttonLabel: "Auditer mon ERP",
    mainText: [
        {
            type: DataType.Text,
            data: []
        }
    ],
    why: {
        title: "Pourquoi auditer mon ERP ?",
        paragraph: [
            {
                type: DataType.Text,
                data: []
            }
        ]
    },
    offerLevels: [],
    tile: {
        title: "Audit Global",
        subtitle: "Parametrage de l'ERP",
        text: [],
        buttonLabel: "En savoir plus",
        href: "/Offer/erpglobalaudit"
    }
}
export const erpFocusTva: IOffer = {
    displayOrder: 1,
    id: 'erpfocustva',
    title: "Focus TVA",
    shortTitle: "Paramétrage de l’ERP - Focus TVA",
    href: "/order/erpfocustva",
    buttonLabel: "Faire un focus sur ma TVA",
    mainText: [
        {
            type: DataType.Text,
            data: []
        }
    ],
    offerLevels: [],
    why: {
        title: "Pourquoi vérifier la gestion de la TVA de l'ERP ?",
        paragraph: []
    },
    tile: {
        title: "Focus TVA",
        subtitle: "Parametrage de l'ERP",
        text: [],
        buttonLabel: "En savoir plus",
        href: "/Offer/erpfocustva"
    }
}
erpConfiguration.subOffers?.push(erpGlobalAudit);
erpConfiguration.subOffers?.push(erpFocusTva);

export const Offers = [fecInfo, eInvoiceReporting, prepCFI, dataGovernance, erpConfiguration, fecFiscalReview, revueFiscaliteLocale, pafInfo, invoiceModelReview];

export const FlattenedOffers = [
    fecInfo, eInvoiceReporting, revueFiscaliteLocale, erpConfiguration, invoiceModelReview, pafInfo, prepCFI, fecFiscalReview, dataGovernance,
    cvaeInfo, etabInduInfo, proLocInfo, lpTaxesUrbanisme, erpGlobalAudit, erpFocusTva];
